import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as NIHLogo } from "../assets/nih.svg";
import { ReactComponent as NSFLogo } from "../assets/NSF_logo.svg";

const AttributionBox = ({ id, open }) => {
  if (!open) {
    return null;
  }

  return (
    <Box
      id={id}
      className="viewer-attribution"
      role="dialog"
      aria-label="Experience information"
      sx={{
        position: "absolute",
        top: "calc(100% + 10px)",
        left: 0,
        width: "min(320px, calc(100vw - 32px))",
        background:
          "var(--surface-gradient-dark, linear-gradient(160deg, rgba(10, 16, 24, 0.88) 0%, rgba(12, 18, 28, 0.8) 100%))",
        color: "#fff",
        px: 2.15,
        py: 1.35,
        zIndex: "var(--start-overlay-chrome-z-index, 2010)",
        overflow: "hidden",
        boxSizing: "border-box",
        borderRadius: "var(--radius-lg, 14px)",
        boxShadow: "var(--surface-shadow, 0 14px 34px rgba(0, 0, 0, 0.34))",
        backdropFilter:
          "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
        WebkitBackdropFilter:
          "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
        pointerEvents: "auto",
      }}
    >
      <Box align="left" sx={{ mb: 1.2 }}>
        <Typography
          variant="overline"
          sx={{ opacity: 0.72, letterSpacing: "0.11em" }}
        >
          About
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 0.35, lineHeight: 1.45, opacity: 0.9 }}
        >
          Made in collaboration with the Innovative Genomics Institute and
          Lawrence Hall of Science at UC Berkeley.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="caption" align="left" sx={{ opacity: 0.86 }}>
          Funding support from
        </Typography>
        <NIHLogo width="50px" />
        <NSFLogo width="35px" />
      </Box>
    </Box>
  );
};

export default AttributionBox;
